// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17QuU","right":"styles_right__3tsWz"};